import axios from "axios";

class Http {
  constructor() {
    const service = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      headers: {
        common: {
          Accept: "application/json",
        },
      },
    });

    service.interceptors.request.use(
      (config) => {
        const { token } = JSON.parse(localStorage.getItem("user"));
        // eslint-disable-next-line no-param-reassign
        if (token) {
          config.headers.common.Authorization = `Bearer ${token}`;
        }

        return config;
      },
      (error) => Promise.reject(error)
    );

    service.interceptors.response.use(
      (response) => response?.data,
      (error) => Promise.reject(error?.response.data)
    );

    this.service = service;
  }

  get(path) {
    return this.service.get(path);
  }

  post(path, payload) {
    return this.service.post(path, payload);
  }

  put(path, payload) {
    return this.service.put(path, payload);
  }

  delete(path, payload) {
    return this.service.delete(path, payload);
  }

  // Fetches a file with the auth header attached and hands it to the browser
  async download(path, fileName) {
    const data = await this.service.get(path, { responseType: "blob" });
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  }
}
export default new Http();
